import Vue from 'vue'
import Router from 'vue-router'
// import page108 from '@/components/page1111/page-10-8-new'
import pageSingle from '@/components/single1121/page1121'
import pageSingle1216 from '@/components/single1216/page1216'
import page260309 from '@/components/page260309/page260309'
import modifyData from '@/components/modify-data/modify-data'
import pageSingle0517 from '@/components/page260618/page0517'
import pageN30 from '@/components/page260618/pagem-n-30'
import page157 from '@/components/page260618/pagem-15-7'
import page74 from '@/components/page260618/pagem-7-4'
import page42 from '@/components/page260618/pagem-4-2'
import page21 from '@/components/page260618/pagem-2-1'
// import page42 from '@/components/page1111/page-1-1'
// import page21Pc from '@/components/page1111/page-2-1-pc'
// import pageSendData from '@/components/page0518/page-send-data'
// import pageSubData from '@/components/page0518/page-sub-data'
// import pageContribution from '@/components/page0518/page-contribution'
import pageGroups from '@/components/page260622/page-groups'
import pageSingle0622 from '@/components/page260622/page-tp-paiming'
import pageTpGroups from '@/components/page260622/page-tp-groups'
import pageTpGroups4 from '@/components/page260622/page-tp-groups4'
import pageTpGroups2 from '@/components/page260622/page-tp-groups2'
import pageModifyData from '@/components/page260622/page-modify-data'
import pageModifyDataJs from '@/components/page260622/page-modify-data-js'
import pageTpPaiming2 from '@/components/page260622/page-tp-paiming2'
import pageTpPaiming4 from '@/components/page260622/page-tp-paiming4'
import pageTpPaimingJs from '@/components/page260622/page-tp-paiming-js'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    // {
    //   path: '/page-0518',
    //   name: 'page0518',
    //   component: page0518
    // },
    // {
    //   path: '/page-0518-pc',
    //   name: 'page0518PC',
    //   component: page0518PC
    // },
    // {
    //   path: '/page-0519',
    //   name: 'page0519',
    //   component: page4010
    // },
    // {
    //   path: '/page-10-8',
    //   name: 'page108',
    //   component: page42
    // },
    // {
    //   path: '/page-0525-pc',
    //   name: 'page0525PC',
    //   component: page108PC
    // },
    // {
    //   path: '/page-0601',
    //   name: 'page0601',
    //   component: page0601
    // },
    // {
    //   path: '/page-0601-pc',
    //   name: 'page0601PC',
    //   component: page0601PC
    // },
    // {
    //   path: '/page-0608',
    //   name: 'page0608',
    //   component: page0608
    // },
    // {
    //   path: '/page-0608-pc',
    //   name: 'page0608PC',
    //   component: page0608PC
    // },
    // {
    //   path: '/page-0615',
    //   name: 'page0615',
    //   component: page0615
    // },
    // {
    //   path: '/page-0615-pc',
    //   name: 'page0615PC',
    //   component: page0615PC
    // },
    // {
    //   path: '/page-send-data',
    //   name: 'pageSendData',
    //   component: pageSendData
    // },
    // {
    //   path: '/page-sub-data',
    //   name: 'pageSubData',
    //   component: pageSubData
    // },
    // {
    //   path: '/page-contribution',
    //   name: 'pageContribution',
    //   component: pageContribution
    // },
    {
      path: '/page-mobile-30',
      name: 'pageN30',
      component: pageN30
    },
    {
      path: '/page-mobile-15-7',
      name: 'page157',
      component: page157
    },
    {
      path: '/page-mobile-7-4',
      name: 'page74',
      component: page74
    },
    {
      path: '/page-mobile-4-2',
      name: 'page42',
      component: page42
    },
    {
      path: '/page-mobile-2-1',
      name: 'page21',
      component: page21
    },
    // {
    //   path: '/page-4-2',
    //   name: 'page42',
    //   component: page42
    // },
    // {
    //   path: '/page-4-2-pc',
    //   name: 'page42Pc',
    //   component: page21Pc
    // },
    {
      path: '/page-single',
      name: 'pageSingle',
      component: pageSingle
    },
    {
      path: '/page-single-1216',
      name: 'pageSingle1216',
      component: pageSingle1216
    },
    {
      path: '/page-single-0517',
      name: 'pageSingle0517',
      component: pageSingle0517
    },
    {
      path: '/page-single-0622',
      name: 'pageSingle0622',
      component: pageSingle0622
    },
    {
      path: '/page-single-0622-2',
      name: 'pageTpPaiming2',
      component: pageTpPaiming2
    },
    {
      path: '/page-single-0622-4',
      name: 'pageTpPaiming4',
      component: pageTpPaiming4
    },
    {
      path: '/page-single-0622-js',
      name: 'pageTpPaimingJs',
      component: pageTpPaimingJs
    },
    {
      path: '/modify-data',
      name: 'modifyData',
      component: modifyData
    },
    {
      path: '/modify-data-js',
      name: 'modifyDataJs',
      component: pageModifyDataJs
    },
    {
      path: '/page-cp-rank',
      name: 'page260309',
      component: page260309
    },
    {
      path: '/page-groups',
      name: 'pageGroups',
      component: pageGroups
    },
    {
      path: '/page-tp-groups',
      name: 'pageTpGroups',
      component: pageTpGroups
    },
    {
      path: '/page-tp-four-groups',
      name: 'pageTpGroups4',
      component: pageTpGroups4
    },
    {
      path: '/page-tp-two-groups',
      name: 'pageTpGroups2',
      component: pageTpGroups2
    },
    {
      path: '/page-modify-data',
      name: 'pageModifyData',
      component: pageModifyData
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js